import axios from 'axios';
import {
  API_URL,
  INSPECTORS_COMPANIES,
  UPDATE_INSPECTOR_COMPANIES,
  SHOW_INSPECTOR_COMPANIES,
  DELETE_INSPECTOR_COMPANIES_PASS,
  CREATE_INSPECTOR_COMPANIES,
  RESTORE_INSPECTOR_COMPANIES,
  DELETE_INSPECTOR_PASS
} from './ConstantService';

export const InspectorsCompaniesService = {
  getAll(params = {}) {
    return axios.get(INSPECTORS_COMPANIES, { params });
  },

  show(id) {
    return axios.get(SHOW_INSPECTOR_COMPANIES.replace('{id}', id));
  },

  create(data) {
    return axios.post(CREATE_INSPECTOR_COMPANIES, data);
  },

  update(id, data) {
    return axios.patch(UPDATE_INSPECTOR_COMPANIES.replace('{id}', id), data);
  },

  delete(id) {
    return axios.delete(DELETE_INSPECTOR_COMPANIES.replace('{id}', id));
  },

  deleteWithPassword(id, password) {
    return axios.post(DELETE_INSPECTOR_COMPANIES_PASS.replace('{id}', id), { password });
  },

  restore(id) {
    return axios.post(RESTORE_INSPECTOR_COMPANIES.replace('{id}', id));
  }
};
